import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CheckButton from "react-validation/build/button";
import { Link } from "react-router-dom";
import CourseModules from "./CourseModules";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Cart.css";
import "./signup.css";
import { Modal } from "react-bootstrap";
// import Form from "react-validation/build/form";
import CourseImg from "../../assets/images/course-placeholder.png";
import GuestuserService from "../../services/guestuser.service";
import { Form } from "react-bootstrap";
import AuthService from "../../services/auth.service";
import { UilInfoCircle } from "@iconscout/react-unicons";

import Select from "react-select";

import countries from "../../common/allcountries.json";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const GuestCatalogCourseOverview = () => {
  const location = useLocation();
  const { cid, price } = location.state;
  const navigate = useNavigate();
  const [enroll, setEnroll] = useState(null);
  // const form = useRef();
  const checkBtn = useRef();

  const [validated, setValidated] = useState(false);

  const [selectedOption, setSelectedOption] = useState(null);
  const [allCountries, setAllCountries] = useState([]);

  const [userDetails, setUserDetails] = useState({
    firstname: "",
    lastname: "",
    username: "",
    password: "",
    cpassword: "",
    mobileno: "",
    organisation: "",
    country: "",
  });

  const [passwordValid, setPasswordValid] = useState({
    startsWithCaps: false,
    containLetterNum: false,
    containSplCht: false,
    eightchlength: false,
    notContainName: true,
    notContainSequence: false,
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const [isDisabled, setIsDisabled] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);

  const [showPasswordRequirements, setShowPasswordRequirements] =
    useState(false);

  const [show, setShow] = useState(false);
  const [signup, setSignup] = useState(false);

  const [guestCartCourses, setGuestCartCourses] = useState([]);

  const [currentCourse, setCurrentCourse] = useState({
    coursename: "",
    courseimg: "",
    coursedescription: "",
    demovideo: "",
  });

  const isContainsLetterNum = (val) => {
    const startsWithCapsRegex = /^[A-Z].*/;
    const containLetterNumRegex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d\W_]+$/;

    const containSplChtRegex =
      /[\@\#\$\%\^\&\*\(\)\[\]\{\}\!\"\'\;\:\,\.\?\/\\\|\<\>\`\~\-\_\=\+]/;

    const notContainSequenceNumRegex = /(123|234|345|456|567|678|789|012)/;
    // const notContainSequenceLetterRegex =
    //   /(abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz)/;

    const notContainSequenceLetterRegex =
      /^(?!.*(?:abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz)).*$/i;

    const eightchlengthRegex = /^.{8,}$/;
    const updatedValid = { ...passwordValid };

    updatedValid.startsWithCaps = startsWithCapsRegex.test(val);
    updatedValid.containLetterNum = containLetterNumRegex.test(val);
    updatedValid.containSplCht = containSplChtRegex.test(val);
    updatedValid.eightchlength = eightchlengthRegex.test(val);
    updatedValid.notContainName =
      val.includes(userDetails.firstname) || val.includes(userDetails.lastname);
    updatedValid.notContainSequence =
      !notContainSequenceNumRegex.test(val) ||
      !notContainSequenceLetterRegex.test(val);

    setPasswordValid(updatedValid);
  };

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setUserDetails({ ...userDetails, country: selectedOption.value });
  };

  const handleOnChange = (event) => {
    const { name, value } = event.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const handlePasswordChange = (event) => {
    const { name, value } = event.target;
    setUserDetails({ ...userDetails, [name]: value });
    isContainsLetterNum(value);
  };

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const toggleCPassword = () => {
    setShowCPassword(!showCPassword);
  };

  const togglePasswordRequirements = () => {
    setShowPasswordRequirements(!showPasswordRequirements);
  };

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = (e, link) => {
    e.preventDefault();
    setShow(true);
  };

  const handleCloseSignup = () => {
    setUserDetails({
      firstname: "",
      lastname: "",
      username: "",
      password: "",
      cpassword: "",
      mobileno: "",
      organisation: "",
      country: "",
    });
    setSignup(false);
  };
  const handleShowSignup = (e) => {
    e.preventDefault();
    setSignup(true);
  };

  const handleSignup = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);

      toast.warn("*Please fill all required fields!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      return;
    }

    const data = {
      firstname: userDetails.firstname,
      lastname: userDetails.lastname,
      email: userDetails.username,
      mobileno: userDetails.mobileno,
      organisation: userDetails.organisation,
      country: userDetails.country,
    };

    setIsDisabled(true);

    toast.warn("Mail Sending Process.!", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

    GuestuserService.addGuestUser(data)
      .then((resp) => {
        console.log(resp.data);

        toast.success("Registered successfully!", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        setUserDetails({
          firstname: "",
          lastname: "",
          username: "",
          password: "",
          cpassword: "",
          mobileno: "",
          organisation: "",
          country: "",
        });

        setSignup(false);

        setIsDisabled(false);
      })
      .catch((e) => console.log(e));

    // if (
    //   !passwordValid.containLetterNum ||
    //   !passwordValid.containSplCht ||
    //   !passwordValid.eightchlength ||
    //   passwordValid.notContainName ||
    //   !passwordValid.notContainSequence ||
    //   !passwordValid.startsWithCaps
    // ) {
    //   toast.warn("Password is not valid as per requiremnet!", {
    //     position: "top-center",
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //   });
    // } else {
    // }
  };

  const getCurrentCourse = (cid) => {
    GuestuserService.getCourseById(cid)
      .then((resp) => {
        console.log(resp.data);
        setCurrentCourse({
          coursename: resp.data.course_info[0].name,
          courseimg: resp.data.course_info[0].course_image,
          coursedescription: resp.data.course_info[0].description,
          demovideo: resp.data.course_info[0].demoVideo,
        });
      })
      .catch((e) => console.log(e));
  };

  const addCoursesToCart = (e, cid) => {
    e.preventDefault();

    GuestuserService.getEstoreCourseById(cid)
      .then((resp) => {
        let cartCourses = resp.data.map((item) => ({
          csid: item.course_id,
          coursename: item.coursename,
          cimg: item.corsimg,
          price: item.price,
        }));

        const updatedArray = [...guestCartCourses, cartCourses];

        setGuestCartCourses(updatedArray);

        let conertedArr = JSON.stringify(updatedArray);

        localStorage.setItem("myDataArray", conertedArr);

        toast.success("Added to cart!", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    getCurrentCourse(cid);
    setAllCountries(
      Array.isArray(countries)
        ? countries.map((country) => ({
            value: country.code,
            label: country.name,
          }))
        : null
    );
  }, []);

  const buyCourse = async (cid, price) => {
    // const user = AuthService.getCurrentUser();
    // const numericPrice = parseFloat(price);
    // if (isNaN(numericPrice)) {
    //   console.error("Invalid price format");
    //   return;
    // }
    // const coursePrice = numericPrice.toFixed(2);
    // const data = {
    //   amt: coursePrice,
    //   csid: cid,
    //   usid: user.user,
    // };
    // CartService.buyCartCourse(data)
    //   .then((response) => {
    //     const resData = response.data;
    //     const plink = resData.split(" ");
    //     const uplink = plink[26].replace('}\n}\n{"plink":"', "");
    //     const flink = uplink.replace("}", "");
    //     const nflink = flink.replace('"', "");
    //     setPaymentLink(nflink);
    //     window.location.href = nflink;
    //     // window.open(`${nflink}`, "_blank");
    //   })
    //   .catch((e) => console.log(e));
  };

  return (
    <div className="row">
      <ToastContainer />
      <div className="row">
        <div className="col-xl-3 col-lg-3" style={{ paddingRight: 0 }}>
          <div className="outer-box">
            <div className="action-flex mb-4">
              <Link to="/CourseCatalog">
                <div className="action-item">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 19.379 19.382"
                    >
                      <g
                        id="left-arrow-in-circular-button-black-symbol"
                        transform="translate(-0.6 511.567)"
                      >
                        <path
                          id="Path_13057"
                          data-name="Path 13057"
                          d="M9.381-511.546A9.911,9.911,0,0,0,4.162-509.4a11.83,11.83,0,0,0-1.457,1.468,10.165,10.165,0,0,0-1.878,3.88A8.145,8.145,0,0,0,.6-501.873a8.145,8.145,0,0,0,.228,2.181,10.088,10.088,0,0,0,1.931,3.945,11.828,11.828,0,0,0,1.468,1.457,10.164,10.164,0,0,0,3.88,1.878,8.146,8.146,0,0,0,2.181.228,8.146,8.146,0,0,0,2.181-.228,10.541,10.541,0,0,0,3.141-1.339A9.712,9.712,0,0,0,19-497.606a9.626,9.626,0,0,0,.914-2.94,12.941,12.941,0,0,0,0-2.655,9.626,9.626,0,0,0-.914-2.94,9.19,9.19,0,0,0-1.889-2.625,9.01,9.01,0,0,0-2.553-1.813,9.581,9.581,0,0,0-2.9-.91A14.607,14.607,0,0,0,9.381-511.546Zm1.1,5.618a.61.61,0,0,1,.25.766c-.03.068-.622.69-1.328,1.392L8.126-502.5l3.315.019c3.277.019,3.319.019,3.421.1a.536.536,0,0,1,.262.508.536.536,0,0,1-.262.508c-.1.08-.144.08-3.421.1l-3.315.019L9.4-499.977c.706.7,1.3,1.324,1.328,1.392a.607.607,0,0,1-.77.808c-.14-.053-3.683-3.588-3.751-3.744a1.386,1.386,0,0,1-.015-.683c.053-.133,3.581-3.679,3.736-3.751A.637.637,0,0,1,10.477-505.928Z"
                          transform="translate(0 0)"
                        />
                      </g>
                    </svg>
                  </span>
                  <span>Back</span>
                </div>
              </Link>
            </div>
            <div className="course-info cat-course-info">
              <div className="course-name">
                <span>{currentCourse.coursename}</span>
              </div>
              <div className="course-modules">
                <label htmlFor="">Course Modules :-</label>
                <CourseModules cid={cid} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-9 col-lg-9" style={{ paddingRight: 0 }}>
          <div className="row mb-3">
            <div className="col-xl-12 col-lg-12">
              <div className="outer-box">
                <div className="course-overview">
                  <div className="course-img">
                    {enroll === null ? (
                      <>
                        {currentCourse.courseimg !== "" ? (
                          <>
                            <div className="course-preview">
                              <div className="overlay"></div>
                              <img
                                src={
                                  "https://exceltest.aeontechhub.com/lms/" +
                                  currentCourse.courseimg
                                }
                                alt=""
                              />
                              <button onClick={(e) => handleShow(e)}>
                                <svg
                                  version="1.1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="36"
                                  height="36"
                                  viewBox="0 0 512 512"
                                >
                                  <path
                                    d="M0 0 C1.79486878 1.00295579 3.58866732 2.00865339 5.35791016 3.05615234 C7.57012898 4.36549028 9.80394675 5.63159777 12.04296875 6.89453125 C15.58108835 8.89665929 19.10811891 10.91677274 22.62890625 12.94921875 C28.60051013 16.38990702 34.60881007 19.76302531 40.625 23.125 C41.66938232 23.70894531 42.71376465 24.29289062 43.78979492 24.89453125 C45.91861821 26.08444121 48.04760654 27.27405593 50.17675781 28.46337891 C64.37385548 36.39424614 78.55960567 44.34430638 92.71142578 52.35571289 C99.75475964 56.34058246 106.81206584 60.29998867 113.875 64.25 C122.8343421 69.26059503 131.77781974 74.29829051 140.7109375 79.35546875 C147.75446347 83.34036769 154.81190717 87.29989994 161.875 91.25 C170.8343421 96.26059503 179.77781974 101.29829051 188.7109375 106.35546875 C195.75446347 110.34036769 202.81190717 114.29989994 209.875 118.25 C218.8343421 123.26059503 227.77781974 128.29829051 236.7109375 133.35546875 C243.75446347 137.34036769 250.81190717 141.29989994 257.875 145.25 C266.8343421 150.26059503 275.77781974 155.29829051 284.7109375 160.35546875 C291.75446347 164.34036769 298.81190717 168.29989994 305.875 172.25 C314.8343421 177.26059503 323.77781974 182.29829051 332.7109375 187.35546875 C339.75446401 191.34036799 346.81196193 195.29980134 353.875 199.25 C363.85386535 204.83242003 373.82317942 210.43105099 383.765625 216.078125 C387.57450419 218.23977722 391.39853649 220.37095831 395.234375 222.484375 C397.11458597 223.53124527 398.9947944 224.57812009 400.875 225.625 C401.72932617 226.0885791 402.58365234 226.5521582 403.46386719 227.02978516 C411.60075701 231.5895017 417.58432021 236.68662623 420.71484375 245.64453125 C422.54900911 252.88351525 421.57636548 258.83577095 418.93359375 265.73046875 C414.09752691 273.54817079 406.9280858 277.57001928 399 281.8125 C396.75504189 283.04136265 394.51025501 284.27053816 392.265625 285.5 C390.54956055 286.43199219 390.54956055 286.43199219 388.79882812 287.3828125 C383.42378887 290.3140946 378.08780676 293.31412307 372.75 296.3125 C370.6640765 297.48049375 368.57813907 298.64846262 366.4921875 299.81640625 C359.66426153 303.64509932 352.85084509 307.49925691 346.03857422 311.35571289 C337.94347336 315.93563509 329.82855836 320.47967662 321.7109375 325.01953125 C314.75530205 328.91158037 307.81114796 332.82333772 300.875 336.75 C291.83559691 341.86734803 282.77685704 346.9493318 273.7109375 352.01953125 C266.75530205 355.91158037 259.81114796 359.82333772 252.875 363.75 C243.83559691 368.86734803 234.77685704 373.9493318 225.7109375 379.01953125 C218.75530205 382.91158037 211.81114796 386.82333772 204.875 390.75 C195.83559691 395.86734803 186.77685704 400.9493318 177.7109375 406.01953125 C170.75530205 409.91158037 163.81114796 413.82333772 156.875 417.75 C147.83559691 422.86734803 138.77685704 427.9493318 129.7109375 433.01953125 C122.75530205 436.91158037 115.81114796 440.82333772 108.875 444.75 C99.83559691 449.86734803 90.77685704 454.9493318 81.7109375 460.01953125 C74.75530205 463.91158037 67.81114796 467.82333772 60.875 471.75 C51.84816942 476.86023054 42.80294095 481.93679618 33.74829102 486.99755859 C28.47877038 489.94472886 23.21578969 492.9026542 17.96484375 495.8828125 C16.93101563 496.46933594 15.8971875 497.05585938 14.83203125 497.66015625 C12.8817896 498.76773204 10.93250097 499.87698839 8.984375 500.98828125 C6.45605668 502.42407078 3.91837508 503.84109311 1.375 505.25 C0.66021484 505.65694092 -0.05457031 506.06388184 -0.79101562 506.4831543 C-8.26013153 510.53552781 -16.44738795 510.78360462 -24.60546875 508.3671875 C-31.68577319 505.13231315 -36.02616202 500.72383206 -39.26134682 493.69467163 C-41.70845022 485.91371717 -41.03719912 477.45752965 -41.00595093 469.38525391 C-41.00940935 467.44524179 -41.01417515 465.50523165 -41.02013266 463.5652256 C-41.03264693 458.24414194 -41.02647025 452.92321987 -41.01717401 447.60213566 C-41.01038565 441.85972567 -41.0208637 436.11734344 -41.02911377 430.37493896 C-41.04245554 419.12947782 -41.03957136 407.88407673 -41.03087585 396.63861322 C-41.02410147 387.49940657 -41.02318152 378.36021675 -41.0264473 369.2210083 C-41.026907 367.92040643 -41.02736669 366.61980457 -41.02784032 365.27979052 C-41.0287995 362.6376659 -41.02977214 359.99554129 -41.0307581 357.35341668 C-41.0390694 333.28294171 -41.03044938 309.21249832 -41.01473031 285.14202848 C-41.00049379 263.17474624 -41.00176769 241.20751616 -41.01611328 219.24023438 C-41.03218179 194.55223189 -41.03848931 169.86425945 -41.02927649 145.17625237 C-41.02832084 142.54383215 -41.02737773 139.91141193 -41.0264473 137.2789917 C-41.02598447 135.98378117 -41.02552164 134.68857064 -41.02504479 133.35411131 C-41.02245422 124.22558938 -41.02682736 115.09708596 -41.03388596 105.96856689 C-41.04229858 94.84438492 -41.04002575 83.72026645 -41.02404372 72.59609175 C-41.01615788 66.92008182 -41.01307486 61.24417779 -41.02299118 55.56816864 C-41.03193193 50.37199509 -41.02701526 45.1760256 -41.01105852 39.97987056 C-41.00770812 38.10045153 -41.0094106 36.22101526 -41.01668589 34.34160733 C-41.09719885 11.81435562 -41.09719885 11.81435562 -33.4609375 3.82421875 C-23.78529794 -4.47212751 -11.42198317 -5.53464267 0 0 Z "
                                    fill="#000000"
                                    transform="translate(65.625,2.75)"
                                  />
                                </svg>
                              </button>
                            </div>
                          </>
                        ) : (
                          <>
                            <img src={CourseImg} width="500px" alt="" />
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {currentCourse.courseimg !== "" ? (
                          <>
                            <img
                              src={
                                "https://exceltest.aeontechhub.com/lms/" +
                                currentCourse.courseimg
                              }
                              alt=""
                            />
                          </>
                        ) : (
                          <>
                            <img src={CourseImg} width="500px" alt="" />
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-xl-12">
              <div className="outer-box">
                <div className="cflex">
                  <div className="heading">
                    <h1>Course Overview</h1>
                  </div>
                </div>

                <div
                  dangerouslySetInnerHTML={{
                    __html: currentCourse.coursedescription,
                  }}
                  className="course-overview"
                />

                <div className="cart-btn-details">
                  <div className="buy-btn">
                    <button onClick={(e) => handleShowSignup(e)}>
                      Buy Now
                    </button>
                  </div>
                  <div className="add-cart-btn">
                    <button onClick={(e) => handleShowSignup(e)}>
                      Add to cart
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Body>
          <div className="mb-3">
            <span>Course Preview</span>
            <h4>{currentCourse.coursename}</h4>
          </div>

          <video controls width="100%" controlsList="nodownload">
            <source
              src={"https://exceltest.aeontechhub.com/lms/" + currentCourse.demovideo}
              type="video/webm"
            />
            <source
              src={"https://exceltest.aeontechhub.com/lms/" + currentCourse.demovideo}
              type="video/mp4"
            />
            Sorry, your browser doesn't support videos.
          </video>
        </Modal.Body>
      </Modal>
      <Modal show={signup} onHide={handleCloseSignup} centered size="md">
        <Modal.Header>
          <Modal.Title>Sign Up</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleCloseSignup}
          >
            <svg
              id="incorrect"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24.472 24.445"
            >
              <path
                id="Path_11894"
                data-name="Path 11894"
                d="M53.513-468.776a12.275,12.275,0,0,0-10.047,8.325,12.483,12.483,0,0,0-.54,5.184A12.274,12.274,0,0,0,53.6-444.485a15.674,15.674,0,0,0,2.842.023,12.26,12.26,0,0,0,9.645-6.8,12.267,12.267,0,0,0,.6-9.283,12.331,12.331,0,0,0-6.419-7.176,12.8,12.8,0,0,0-3.829-1.079A17.215,17.215,0,0,0,53.513-468.776Zm-2.2,6.723c.1.052,1,.9,1.986,1.877l1.791,1.791,1.8-1.791c.982-.982,1.872-1.826,1.969-1.877a1.151,1.151,0,0,1,1.407.247,1.152,1.152,0,0,1,.247,1.407c-.052.1-.9.987-1.877,1.969l-1.791,1.8,1.791,1.791c.982.987,1.831,1.889,1.889,2a1.5,1.5,0,0,1,.011,1.062,1.9,1.9,0,0,1-.62.609,1.561,1.561,0,0,1-1.033-.029c-.109-.057-1.01-.907-1.992-1.889l-1.8-1.791L53.3-453.091c-.987.982-1.877,1.826-1.975,1.877a1.152,1.152,0,0,1-1.407-.247,1.152,1.152,0,0,1-.247-1.407c.052-.1.9-.987,1.877-1.975l1.791-1.791-1.791-1.8c-.982-.982-1.826-1.872-1.877-1.969a1.254,1.254,0,0,1,.746-1.745A1.431,1.431,0,0,1,51.314-462.053Z"
                transform="translate(-42.855 468.853)"
                // fill="#fff"
              />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="signup active">
            {message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {message}
                </div>
              </div>
            )}
            <Form noValidate validated={validated} onSubmit={handleSignup}>
              <div className="">
                <div className="row">
                  <div className="col-lg-6">
                    <Form.Group className="mb-3" controlId="firstname">
                      <Form.Label>First Name *</Form.Label>
                      <div className="input-box">
                        <Form.Control
                          type="text"
                          placeholder="Enter First Name"
                          name="firstname"
                          value={userDetails.firstname}
                          onChange={handleOnChange}
                          required
                          validations={[required]}
                        />
                        <span className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 20.199 20.201"
                          >
                            <g
                              id="Group_11227"
                              data-name="Group 11227"
                              transform="translate(-2402.326 -6200.833)"
                            >
                              <path
                                id="Path_11890"
                                data-name="Path 11890"
                                d="M1654.058,694.916h-1.132a2.254,2.254,0,0,0-1.595.662,2.23,2.23,0,0,0-.662,1.6V707.34a2.231,2.231,0,0,0,.662,1.6,2.254,2.254,0,0,0,1.595.662h10.165a2.259,2.259,0,0,0,2.256-2.26v-1.129"
                                transform="translate(752.656 5510.435)"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                              />
                              <path
                                id="Path_11892"
                                data-name="Path 11892"
                                d="M1665.659,691.509l3.389,3.389m1.563-1.6a2.373,2.373,0,0,0-3.356-3.355l-9.5,9.471V702.8h3.389Z"
                                transform="translate(751.221 5511.583)"
                              />
                            </g>
                          </svg>
                        </span>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-lg-6">
                    <Form.Group className="mb-3" controlId="lastname">
                      <Form.Label>Last Name *</Form.Label>
                      <div className="input-box">
                        <Form.Control
                          type="text"
                          placeholder="Enter Last Name"
                          name="lastname"
                          value={userDetails.lastname}
                          onChange={handleOnChange}
                          required
                          validations={[required]}
                        />
                        <span className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 20.199 20.201"
                          >
                            <g
                              id="Group_11227"
                              data-name="Group 11227"
                              transform="translate(-2402.326 -6200.833)"
                            >
                              <path
                                id="Path_11890"
                                data-name="Path 11890"
                                d="M1654.058,694.916h-1.132a2.254,2.254,0,0,0-1.595.662,2.23,2.23,0,0,0-.662,1.6V707.34a2.231,2.231,0,0,0,.662,1.6,2.254,2.254,0,0,0,1.595.662h10.165a2.259,2.259,0,0,0,2.256-2.26v-1.129"
                                transform="translate(752.656 5510.435)"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                              />
                              <path
                                id="Path_11892"
                                data-name="Path 11892"
                                d="M1665.659,691.509l3.389,3.389m1.563-1.6a2.373,2.373,0,0,0-3.356-3.355l-9.5,9.471V702.8h3.389Z"
                                transform="translate(751.221 5511.583)"
                              />
                            </g>
                          </svg>
                        </span>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-lg-12">
                    <Form.Group className="mb-3" controlId="username">
                      <Form.Label>Email *</Form.Label>
                      <div className="input-box">
                        <Form.Control
                          type="email"
                          placeholder="Enter Email"
                          name="username"
                          value={userDetails.username}
                          onChange={handleOnChange}
                          required
                          validations={[required]}
                        />
                        <span className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 20.199 20.201"
                          >
                            <g
                              id="Group_11227"
                              data-name="Group 11227"
                              transform="translate(-2402.326 -6200.833)"
                            >
                              <path
                                id="Path_11890"
                                data-name="Path 11890"
                                d="M1654.058,694.916h-1.132a2.254,2.254,0,0,0-1.595.662,2.23,2.23,0,0,0-.662,1.6V707.34a2.231,2.231,0,0,0,.662,1.6,2.254,2.254,0,0,0,1.595.662h10.165a2.259,2.259,0,0,0,2.256-2.26v-1.129"
                                transform="translate(752.656 5510.435)"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                              />
                              <path
                                id="Path_11892"
                                data-name="Path 11892"
                                d="M1665.659,691.509l3.389,3.389m1.563-1.6a2.373,2.373,0,0,0-3.356-3.355l-9.5,9.471V702.8h3.389Z"
                                transform="translate(751.221 5511.583)"
                              />
                            </g>
                          </svg>
                        </span>
                      </div>
                    </Form.Group>
                  </div>
                  {/* <div className="col-lg-6">
                    <Form.Group
                      className="mb-3 togglePassword"
                      controlId="password"
                    >
                      <Form.Label className="d-flex justify-content-between">
                        Password *
                        <UilInfoCircle
                          size="20"
                          color="#ffc107"
                          onClick={togglePasswordRequirements}
                        />
                      </Form.Label>
                      <div className="input-box">
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter Password"
                          name="password"
                          value={userDetails.password}
                          onChange={handlePasswordChange}
                          required
                          validations={[required]}
                        />
                        <i
                          className={
                            showPassword ? "uil uil-eye" : "uil uil-eye-slash"
                          }
                          id="eye-icon"
                          onClick={togglePassword}
                        ></i>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-lg-6">
                    <Form.Group
                      className="mb-3 togglePassword"
                      controlId="cpassword"
                    >
                      <Form.Label>Confirm Password *</Form.Label>
                      <div className="input-box">
                        <Form.Control
                          type={showCPassword ? "text" : "password"}
                          placeholder="Enter Confirm Password"
                          name="cpassword"
                          value={userDetails.cpassword}
                          onChange={handlePasswordChange}
                          required
                          validations={[required]}
                        />
                        <i
                          className={
                            showCPassword ? "uil uil-eye" : "uil uil-eye-slash"
                          }
                          id="eye-icon"
                          onClick={toggleCPassword}
                        ></i>
                      </div>
                    </Form.Group>
                  </div> */}
                </div>

                {/* {showPasswordRequirements ? (
                  <>
                    <ul className="psw-valid">
                      <li
                        className={
                          passwordValid.startsWithCaps ? "valid" : "invalid"
                        }
                      >
                        Password must start with a capital letter.
                      </li>
                      <li
                        className={
                          passwordValid.containLetterNum ? "valid" : "invalid"
                        }
                      >
                        Password must contain both letters and numbers.
                      </li>
                      <li
                        className={
                          passwordValid.containSplCht ? "valid" : "invalid"
                        }
                      >
                        Password must contain at least one special character
                        (e.g., @, #, $).
                      </li>
                      <li
                        className={
                          passwordValid.eightchlength ? "valid" : "invalid"
                        }
                      >
                        Password must be at least 8 characters long.
                      </li>
                      <li
                        className={
                          !passwordValid.notContainName ? "valid" : "invalid"
                        }
                      >
                        Password must not contain your first or last name.
                      </li>
                      <li
                        className={
                          passwordValid.notContainSequence ? "valid" : "invalid"
                        }
                      >
                        Password must not contain sequential letters or numbers
                        (e.g., abc, 123).
                      </li>
                    </ul>
                  </>
                ) : (
                  <></>
                )} */}

                <Form.Group className="mb-3" controlId="mobileno">
                  <Form.Label>Mobile No.</Form.Label>
                  <div className="input-box">
                    <Form.Control
                      type="text"
                      placeholder="Enter Mobile No"
                      name="mobileno"
                      value={userDetails.mobileno}
                      onChange={handleOnChange}
                    />
                    <span className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 20.199 20.201"
                      >
                        <g
                          id="Group_11227"
                          data-name="Group 11227"
                          transform="translate(-2402.326 -6200.833)"
                        >
                          <path
                            id="Path_11890"
                            data-name="Path 11890"
                            d="M1654.058,694.916h-1.132a2.254,2.254,0,0,0-1.595.662,2.23,2.23,0,0,0-.662,1.6V707.34a2.231,2.231,0,0,0,.662,1.6,2.254,2.254,0,0,0,1.595.662h10.165a2.259,2.259,0,0,0,2.256-2.26v-1.129"
                            transform="translate(752.656 5510.435)"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          />
                          <path
                            id="Path_11892"
                            data-name="Path 11892"
                            d="M1665.659,691.509l3.389,3.389m1.563-1.6a2.373,2.373,0,0,0-3.356-3.355l-9.5,9.471V702.8h3.389Z"
                            transform="translate(751.221 5511.583)"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </Form.Group>

                <Form.Group className="mb-3" controlId="organisation">
                  <Form.Label>Organisation</Form.Label>
                  <div className="input-box">
                    <Form.Control
                      type="text"
                      placeholder="Enter Organisation"
                      name="organisation"
                      value={userDetails.organisation}
                      onChange={handleOnChange}
                    />
                    <span className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 20.199 20.201"
                      >
                        <g
                          id="Group_11227"
                          data-name="Group 11227"
                          transform="translate(-2402.326 -6200.833)"
                        >
                          <path
                            id="Path_11890"
                            data-name="Path 11890"
                            d="M1654.058,694.916h-1.132a2.254,2.254,0,0,0-1.595.662,2.23,2.23,0,0,0-.662,1.6V707.34a2.231,2.231,0,0,0,.662,1.6,2.254,2.254,0,0,0,1.595.662h10.165a2.259,2.259,0,0,0,2.256-2.26v-1.129"
                            transform="translate(752.656 5510.435)"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          />
                          <path
                            id="Path_11892"
                            data-name="Path 11892"
                            d="M1665.659,691.509l3.389,3.389m1.563-1.6a2.373,2.373,0,0,0-3.356-3.355l-9.5,9.471V702.8h3.389Z"
                            transform="translate(751.221 5511.583)"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </Form.Group>

                <Form.Group className="mb-3" controlId="country">
                  <Form.Label>Country</Form.Label>
                  <div className="input-box">
                    <Select
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          width: "100%",
                          height: "50px",
                          border: "none",
                          outline: "none",
                          borderRadius: "10px",
                          backgroundColor: state.isFocused
                            ? "var(--body-dark-bg)"
                            : "var(--body-dark-bg)",
                        }),
                        option: (baseStyles, { isFocused, isSelected }) => ({
                          ...baseStyles,
                          backgroundColor: isSelected
                            ? "var(--primary-color)"
                            : isFocused
                            ? "var(--secondary-color)"
                            : "var(--body-dark-bg)",
                          color: isSelected
                            ? "var(--body-dark-bg)"
                            : isFocused
                            ? "var(--body-dark-bg)"
                            : "var(--whiteColor)",
                        }),
                      }}
                      onChange={handleChange}
                      value={selectedOption}
                      options={allCountries}
                      issearchable="true"
                      placeholder="Select country"
                    />
                  </div>
                </Form.Group>

                <div className="form-group action">
                  <div className="flex_form-group">
                    <button
                      className="fill_btn"
                      type="submit"
                      name="btn_login"
                      disabled={isDisabled}
                    >
                      Signup
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default GuestCatalogCourseOverview;
